import React, { PureComponent } from 'react';

import { Form, Radio, Slider } from 'antd';
import { services } from '@comall-backend-builder/core';
import { language } from '../../../language';
import { ColorPicker, EntryList, ConfigFormDecorator, FormItemLayout } from '../../tools';
import { NavItem } from './nav-item';
import { NavTips } from './nav-tips';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

const interpolate = services.interpolate;
const MAX_ENTRY_COUNT = 99;
/**
 * 导航组件-配置表单
 */
class nav extends PureComponent<any> {
    WrapNavItem = (props) => {
        const { value, uploadAction, selector, sourceRoot } = this.props;
        return (
            <NavItem
                {...props}
                sourceRoot={sourceRoot}
                selector={selector}
                uploadAction={uploadAction}
                key={props.index}
                showStyle={value.showStyle}
            />
        );
    };

    render() {
        const {
            form: { getFieldDecorator },
            linkTypes,
            linkTypeMode,
        } = this.props;

        console.log('----------nav props:---------' + this.props);
        const formItemLayout = FormItemLayout;

        return (
            <Form className="editor-categories-nav">
                <FormItem {...formItemLayout} label={language.getText('components.Nav.selectType')}>
                    {getFieldDecorator(
                        'showStyle',
                        {}
                    )(
                        <RadioGroup className="show-style">
                            <Radio value={'image'}>
                                {language.getText('components.Nav.graphic')}
                            </Radio>
                            <Radio value={'text'}>{language.getText('components.Nav.text')}</Radio>
                        </RadioGroup>
                    )}
                </FormItem>
                <FormItem {...formItemLayout} label={language.getText('components.Nav.number')}>
                    {getFieldDecorator('count')(
                        <RadioGroup className="nav-num">
                            <Radio value={4}>
                                <span className={'nav-num'}>一行四个</span>
                            </Radio>
                            <Radio value={5}>
                                <span className={'nav-num'}>一行五个</span>
                            </Radio>
                        </RadioGroup>
                    )}
                </FormItem>
                <FormItem {...formItemLayout} label={language.getText('components.Nav.color')}>
                    {getFieldDecorator('textColor', {})(<ColorPicker />)}
                </FormItem>
                <FormItem {...formItemLayout} label={language.getText('components.Nav.pageMargin')}>
                    {getFieldDecorator('margin')(<Slider max={48} min={0} />)}
                </FormItem>
                <FormItem>
                    {getFieldDecorator('entry', {
                        initialValue: [],
                    })(
                        <EntryList
                            linkTypes={linkTypes}
                            linkTypeMode={linkTypeMode}
                            maxCount={MAX_ENTRY_COUNT}
                            renderItem={this.WrapNavItem}
                            renderTips={NavTips}
                        />
                    )}
                </FormItem>
                <p className="entry-tip">
                    {interpolate(language.getText('components.ImageAd.tips'), {
                        max: 99,
                    })}
                </p>
            </Form>
        );
    }
}

export const Nav = ConfigFormDecorator(nav);
